import React from 'react';
import Image from 'next/image';
import ErrorIcon from '@public/common/icon/error_page_icon.svg';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import BasicButton from '@components/common/button/BasicButton';
import Link from 'next/link';

export enum ErrorPageButtonKey {
  HOME = 'home',
  PREVIOUS = 'previous',
}

interface Props {
  statusCode: number;
  buttons?: ErrorPageButtonKey[];
}

const Error = ({ statusCode, buttons }: Props) => {
  const router = useRouter();
  const { t, ready } = useTranslation(['errorPage', 'button']);
  const errorPageKey = statusCode === 404 ? statusCode : 'clientSide';

  const buttonDatas = {
    [ErrorPageButtonKey.HOME]: {
      content: t('button:home'),
      onClickHandler: () => {
        router.push('/');
      },
    },
    [ErrorPageButtonKey.PREVIOUS]: {
      content: t('button:previous'),
      onClickHandler: () => {
        router.back();
      },
    },
  };

  return (
    <>
      <section
        className={`flex flex-col gap-8 justify-center items-center h-[100dvh]`}
      >
        <article className={`h-[30%] flex-grow`}></article>
        <article
          className={`h-[30%] flex-grow flex flex-col justify-center items-center gap-8`}
        >
          <div className={`flex justify-center items-center flex-col`}>
            <Image src={ErrorIcon}></Image>
            <h1 className={`text-my-gray-10 text-heading-md-700 my-4`}>
              {ready ? t(`errorPage:${errorPageKey}.title`) : ''}
            </h1>
            <span
              className={`text-my-gray-30 text-body-lg-500 text-center`}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {ready ? t(`errorPage:${errorPageKey}.text`) : ''}
            </span>
          </div>

          <div className={`flex gap-4`}>
            {buttons.map((buttonKey: ErrorPageButtonKey, index) => (
              <BasicButton
                key={buttonKey}
                color={'blue'}
                assetType={
                  buttons.length == 1
                    ? 'Primary'
                    : index === 0
                    ? 'Secondary'
                    : 'Primary'
                }
                size={'M'}
                content={buttonDatas[buttonKey]['content']}
                onClickEvent={buttonDatas[buttonKey]['onClickHandler']}
              ></BasicButton>
            ))}
          </div>
        </article>

        <article
          className={`flex flex-col items-center gap-2 h-[30%] flex-grow pt-8`}
        >
          <div className={`text-my-gray-30 text-label-lg-500`}>
            {ready ? t('errorPage:clearCache.question') : ''}
          </div>
          <Link
            href={
              'https://support.google.com/accounts/answer/32050?hl=ko&co=GENIE.Platform%3DAndroid'
            }
          >
            <a className={`text-my-blue-60 text-label-lg-500 cursor-pointer`}>
              {ready ? t('errorPage:clearCache.answer') : ''}
            </a>
          </Link>
        </article>
      </section>
    </>
  );
};

export default Error;
